import React, { Component } from "react";
import { message } from "antd";
import axios from "axios";
import {
  ModalItem,
  Form,
  FormItem,
  InputItem,
  ButtonItem,
  ErrorItem
} from "../../../../../Components/Items";

class ModalAgregarTutorial extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
  };

  componentDidUpdate(prevProps) {
    // Si se abre el modal → limpia el formulario
    if (prevProps.visible !== this.props.visible && this.props.visible) {
      if (this.formRef.current) {
        this.formRef.current.resetFields();
      }
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish = (values) => {
    this.setState({ loading: true });

    axios
      .post("tutoriales/agregarTutorial", values)
      .then((res) => {
        this.setState({ loading: false });

        message.success("Tutorial agregado correctamente");
        this.cerrar();
        this.props.recargar();
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al agregar");
      });
  };

  cerrar = () => {
    this.props.onClose();
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };

  render() {
    return (
      <ModalItem
        title="Agregar Tutorial"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrar}
      >
        <Form
          ref={this.formRef}
          layout
          name="modalAgregarTutorial"
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem
            name="titulo"
            label="Título"
            required
            margin
          >
            <InputItem placeholder="Título del video" />
          </FormItem>

          <FormItem
            name="descripcion"
            label="Descripción"
            required
            margin
          >
            <InputItem type="textarea" rows={3} placeholder="Descripción" />
          </FormItem>

          <FormItem
            name="url"
            label="URL del Video"
            required
            margin
          >
            <InputItem placeholder="URL del video (YouTube)" />
          </FormItem>

          <FormItem
            name="duracion"
            label="Duración"
            required
            margin
          >
            <InputItem placeholder="Ej: 10:30" />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

export default ModalAgregarTutorial;
